<ngx-auth-firebaseui-user (onSignOut)="onSignOutOrDelete()" (onAccountDeleted)="onSignOutOrDelete()">
</ngx-auth-firebaseui-user>